import { LoadingPage } from '../../../../shared/components/LoadingPage';
import { Table } from "antd";
import { useGetClienteEstoque } from "../../hooks/useGetClientesEstoque";
import { colunasEstoque } from "../../util/vEstoqueCol";

interface ProdutoEstoqueClienteProps {
  clienteId: number
}

export function ProdutoEstoqueCliente({ clienteId } : ProdutoEstoqueClienteProps) {
  const { data: EstoqueCliente, isLoading } = useGetClienteEstoque(clienteId);
  const EstoqueClienteData = EstoqueCliente?.map((estoque: any, index: number) => ({
    key: index,
    ...estoque,
  }));

  return (
    <div className="w-full overflow-hidden overflow-y-auto">
      {isLoading ? <LoadingPage /> :
        <Table
          pagination={{defaultPageSize: 10, showSizeChanger: false}}
          dataSource={EstoqueClienteData}
          columns={colunasEstoque}
        />
      }
    </div>
  );
}